var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 33,
    viewBox: "0 0 18 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.30469 21.5566L3.94497 30.371C4.13844 31.0169 4.94718 31.2285 5.43223 30.7602L12.3516 24.0801",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.95182 2.37298L12.9567 3.06701C14.5711 3.43987 15.5775 5.05082 15.2046 6.66518L14.7917 8.45292C13.3881 7.24722 11.6133 6.57167 9.93993 6.26197C8.49606 5.99475 7.08349 5.99187 5.99305 6.18216L6.35365 4.6209C6.72651 3.00655 8.33746 2.00012 9.95182 2.37298ZM14.5172 9.56086L14.5414 9.53669L11.3465 23.3696C9.96369 22.2306 8.24489 21.5858 6.62157 21.2854C5.10677 21.0051 3.62642 21.0157 2.51636 21.235L5.74494 7.25642C6.70255 7.01209 8.18284 6.95376 9.75795 7.24528C11.4807 7.56412 13.2447 8.28835 14.5172 9.56086ZM10.8939 24.2978C9.65272 23.2018 8.0286 22.5628 6.43959 22.2687C4.80821 21.9668 3.27853 22.0401 2.32596 22.3068L0.34375 21.8461C0.364339 21.6963 0.391872 21.546 0.426574 21.3958L4.40495 4.17082C5.02639 1.48023 7.71131 -0.197149 10.4019 0.424285L13.4068 1.11831C16.0974 1.73974 17.7748 4.42467 17.1533 7.11526L13.1749 24.3402C13.1389 24.4963 13.0959 24.649 13.0464 24.798L10.8939 24.2978Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/IconEdit.c6347cebfdf4c26573cd8384a83c551e.svg";
export { ForwardRef as ReactComponent };